import { JsonObject } from 'json2typescript';
import { PaginationAndSorting } from './pagination-and-sorting-model';

@JsonObject('ClaimDetailFilters')
export class ClaimDetailFilters extends PaginationAndSorting {}
